/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {PncFullLotNumberChipModel} from './models/pnc-full-lot-number-chip.model';

@Component({
    selector: 'app-pnc-full-lot-number-chip',
    templateUrl: './pnc-full-lot-number-chip.component.html',
    styleUrls: ['./pnc-full-lot-number-chip.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PncFullLotNumberChipComponent {
    @Input() data: PncFullLotNumberChipModel;
    @Input() position: number;
    @Input() isWithinLimit: boolean;
    @Output() deleteChip = new EventEmitter<string>();
    // Character limit for chip, to prevent the repetition of labels in case of an invalid chip that is less than 8 characters. This limit
    // ensures that only hidden labels appear.
    private readonly chipLengthInChar = 8;

    get chipColorClass(): string {
        let className = 'invalid';
        if ( this.data.isValid) {
            className = this.isWithinLimit ? 'valid' : 'exceeded';
        }
        return className;
    }

    constructor() {
    }

    chipDataCy(label: string): string {
        return `${label}-${this.position}`;
    }

    onChipDelete(): void {
        this.deleteChip.emit(this.data.id);
    }

    showFullLotNumberOnInvalidChip(): boolean {
        return this.data.fullLotNumber.length > this.chipLengthInChar;
    }
}
